export default __webpack_public_path__ + "assets/705943ba84c045a900eaf4c76ee90bfb/amenities-01.jpg";